import { render, staticRenderFns } from "./fcwpHomeMenu.vue?vue&type=template&id=9350ec4a&"
import script from "./fcwpHomeMenu.vue?vue&type=script&lang=js&"
export * from "./fcwpHomeMenu.vue?vue&type=script&lang=js&"
import style0 from "./fcwpHomeMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports